import { lazy, Suspense } from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import { Layout } from "@/components/Layout"
import { ProtectedRoute } from "@/components/ProtectedRoute"
import { ErrorBoundary } from "@/components/ErrorBoundary"

const Login = lazy(() => import("@/pages/Login"))
const Overview = lazy(() => import("@/pages/Overview"))
const Leads = lazy(() => import("@/pages/Leads"))
const Settings = lazy(() => import("@/pages/Settings"))
const Demand = lazy(() => import("@/pages/Demand"))
const Account = lazy(() => import("@/pages/Account"))

function PageLoader() {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="animate-pulse text-muted-foreground text-sm">Loading...</div>
    </div>
  )
}

export function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<ErrorBoundary><Overview /></ErrorBoundary>} />
          <Route path="leads" element={<ErrorBoundary><Leads /></ErrorBoundary>} />
          <Route path="demand" element={<ErrorBoundary><Demand /></ErrorBoundary>} />
          <Route path="settings" element={<ErrorBoundary><Settings /></ErrorBoundary>} />
          <Route path="account" element={<ErrorBoundary><Account /></ErrorBoundary>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}
